import ApiService from './ApiService'

export async function apiSignIn(data) {
    return ApiService.fetchData({
        url: '/authentication_token',
        method: 'post',
        data
    })
}

export async function getUser(username) {
    return ApiService.fetchData({
        url: '/users?email=' + username,
        method: 'get'
    })
}

export async function apiSignUp(data) {
    return ApiService.fetchData({
        url: '/register',
        method: 'post',
        data
    })
}


export async function apiSignOut(data) {
    return ApiService.fetchData({
        url: '/logout',
        method: 'post',
        data
    })
}

export async function apiForgotPassword(data) {
    return ApiService.fetchData({
        url: '/forgot-password',
        method: 'post',
        data
    })
}

export async function apiResetPassword(data) {
    return ApiService.fetchData({
        url: '/reset-password',
        method: 'post',
        data
    })
}
